import React from 'react';

/**
 * Nav-bar trigger for the data export feature.
 *
 * Icon: a box (tray) with an arrow exiting the top — the universal
 * "export" glyph. Same sizing/border language as QuickSaveButton so it
 * sits cleanly to the left of it in the `.saved-searches-buttons` row.
 *
 * Behavior is gated upstream: non-subscribers still render this button
 * so they see the Pro-upgrade prompt on click.
 */
function ExportButton({ onClick, isSubscriber = false, disabled = false, label = null }) {
  const tooltip = isSubscriber
    ? 'Export data'
    : 'Pro feature: Export data. Click "Get Pro" to upgrade.';

  return (
    <button
      className="export-button"
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      aria-label={tooltip}
    >
      <svg
        className="export-button__icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
      {label && <span className="export-button__label">{label}</span>}
    </button>
  );
}

export default ExportButton;
